import axios from 'axios';
import { BASEURL } from '../Config';
import store from '../redux/store';
import { logout } from '../redux/actions/authActions';

// Centralized Axios instance
const api = axios.create({
  baseURL: BASEURL,
});

// Attach Authorization header from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    if (!config.headers) config.headers = {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Enhanced 401 handling with automatic logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Only logout if we have a token (avoid logout on login/signup failures)
      const token = localStorage.getItem('token');
      if (token) {
        // Dispatch logout action to clear Redux state and redirect
        store.dispatch(logout());
      }
    }
    return Promise.reject(error);
  }
);

export default api;


